import React from 'react'
import ImageVideoData from '../../Components/Data/ImageVideoData'

const index = props => {
  return <ImageVideoData />
}

export default index
